import { subscribeToEvent } from '../tools/event-subscribe';

const letterRanges = [
  ['0041', '005A'], // Latin Alphabet Uppercase
  ['0400', '04FF'], // Cyrillic
  ['00C0', '00D6'],
];

const strRanges = letterRanges.map(([start, end]) => `\\u${start}-\\u${end}`).join('');

const letterRegexp = new RegExp(`[${strRanges}]`, 'i');


export function capitalizeStringsCollector(onData) {
  const data = [0, 0];
  /**
     *
     * @param {KeyboardEvent} e
     */
  function handleKeyDown(e) {
    const target = e.target;

    if (target instanceof HTMLInputElement) {
      if (!target.value.length) {
        const { key } = e;
        if (key.length === 1
          && letterRegexp.test(key)
        ) {
          const upperCase = key !== key.toLocaleLowerCase();
          data[+upperCase]++;
          onData(upperCase);
        }
      }
    }
  }

  const subscriptions = [subscribeToEvent(window, 'keydown', handleKeyDown, { capture: true })];

  function stop() {
    subscriptions.forEach(u => u());
  }

  function toString() {
    return data.length ? data.join('|') : '';
  }

  return {
    data,
    toString,
    stop,
  };
}



// WEBPACK FOOTER //
// ./src/lib/collectors/capitalize-string.js